import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { INommable } from '../nommable.interface';
import { UUID } from '../uuid.model';
import { DeclarationPosition } from './declaration-position.model';
import { Declaration } from './declaration.model';
import { IVacation } from './vacation.interface';

export class VacationIntervention implements IVacation {
  constructor(
    public id: UUID,
    public debut: dayjs.Dayjs,
    public arriveeSurSite: dayjs.Dayjs | undefined,
    public fin?: dayjs.Dayjs,
    public anomalies: Declaration[] = [],
    // public infos: Declaration[] = [],
    public positionsDeclarees: DeclarationPosition[] = [],
    public site?: INommable,
    public type = CreneauType.INTERVENTION
  ) {}

  public static hydrate(vacation: VacationIntervention): VacationIntervention {
    return new VacationIntervention(
      vacation.id,
      dayjs(vacation.debut),
      vacation.arriveeSurSite ? dayjs(vacation.arriveeSurSite) : undefined,
      vacation.fin ? dayjs(vacation.fin) : undefined,
      vacation.anomalies?.length > 0 ? vacation.anomalies.map(a => Declaration.hydrate(a)) : [],
      // vacation.infos?.length > 0 ? vacation.infos.map(a => Declaration.hydrate(a)) : [],
      vacation.positionsDeclarees?.length > 0 ? vacation.positionsDeclarees.map(DeclarationPosition.hydrate) : [],
      vacation.site,
      vacation.type
    );
  }
}
